export default {
  title: 'Ustawienie',
  type: 'object',
  properties: {
    code: {
      title: 'schema.setting.code',
      type: 'string',
      fieldRequired: true
    },
    description: {
      title: 'schema.setting.description',
      type: 'string',
      fieldRequired: false
    },
    value: {
      title: 'schema.setting.value',
      type: 'string',
      fieldRequired: true
    },
    valueType: {
      title: 'schema.setting.valueType',
      type: 'string',
      fieldRequired: false
    },
    groupId: {
      title: 'schema.setting.groupId',
      type: 'number',
      fieldRequired: false
    }
  }
};
